<template>
  <b-card>
    <div
      class="table-header-border-bottom pb-1 mb-md-3 d-flex justify-content-between align-items-center"
    >
      <h3 class="mt-1 d-flex align-items-center">
        <feather-icon
          icon="CheckSquareIcon"
          class="mr-50"
          style="width: 18px; height: 18px"
        />
        <span>Transfers</span>
      </h3>
    </div>
    <b-form
      @submit.prevent="filter"
      class="filters rounded p-1 my-md-1 d-flex align-items-center justify-content-between flex-wrap"
    >
      <div class="col-sm-3 col-12 p-50 d-flex align-items-center">
        <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
        <v-select
          :options="types"
          v-model="type"
          label="label"
          :reduce="(option) => option.value"
          :searchable="false"
          placeholder="Display on the page"
          class="w-100"
        ></v-select>
      </div>

      <div class="col-sm-6 col-12 d-flex align-items-center flex-wrap p-50">
        <template v-if="type == 'to' || type == 'from'">
          <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
            <select-box
              v-model="payable_type"
              class="w-100"
              searchable
              :lists="['user', 'partner', 'competition', 'plan']"
            />
          </div>
          <div class="col-md-6 col-12 py-50 px-sm-50 px-0">
            <select-box
              v-model="payable_id"
              label="text"
              class="w-100"
              select="id"
              searchable
              :url="payable_type"
            />
          </div>
        </template>

        <b-form-input
          v-else
          placeholder="search"
          v-model.trim="search"
          :disabled="!type"
        />
      </div>
      <div class="col-sm-3 col-12 p-50">
        <b-button
          class="w-100"
          type="submit"
          :disabled="!search && !(!search && payable_type && payable_id)"
        >
          <span class="text-muted h5"> Filtering</span>
        </b-button>
      </div>
    </b-form>
    <data-table :fields="fields" :items="transfers" :loading="loading">
      <template #uuid="{ data }">
        <div
          class="d-flex align-items-center"
          v-b-tooltip.hover="data.item.uuid"
        >
          <div class="text-truncate" style="max-width: 250px">
            {{ data.item.uuid }}
          </div>
          <div>
            <feather-icon
              icon="CopyIcon"
              width="40px"
              class="ml-sm-75 cursor-pointer"
              @click="doCopy(data.item.uuid)"
            />
          </div>
        </div>
      </template>
      <template #from="{ data }">
        <span class="mb-0">
          {{
            data.item.from.data.holder_type
              ? `${data.item.from.data.holder_type} -`
              : "-"
          }}
        </span>
        <span class="nowrap-white-space">
          {{
            hasOwnNestedProperty(data.item, "from.data.holder.first_name")
              ? data.item.from.data.holder.first_name +
                " " +
                data.item.from.data.holder.last_name
              : hasOwnNestedProperty(data.item, "from.data.holder.name")
              ? data.item.from.data.holder.name
              : "-"
          }}
        </span>
      </template>
      <template #to="{ data }">
        <span class="mb-0">
          {{
            data.item.to.data.holder_type
              ? `${data.item.to.data.holder_type} -`
              : "-"
          }}
        </span>
        <span class="nowrap-white-space">
          {{
            hasOwnNestedProperty(data.item, "to.data.holder.first_name")
              ? data.item.to.data.holder.first_name +
                " " +
                data.item.to.data.holder.last_name
              : hasOwnNestedProperty(data.item, "to.data.holder.name")
              ? data.item.to.data.holder.name
              : "-"
          }}
        </span>
      </template>
      <template #amount="{ data }">
        <span class="mb-0 text-green nowrap-white-space">
          {{
            hasOwnNestedProperty(data.item, "withdraw.data.amount_float")
              ? `${Math.abs(data.item.withdraw.data.amount_float).toFixed(2)}$`
              : "-"
          }}
        </span>
      </template>
      <template #fee="{ data }">
        <span class="mb-0">
          {{ data.item.fee ? `${data.item.fee}$` : "-" }}
        </span>
      </template>

      <template #discount="{ data }">
        <span class="mb-0">
          {{ data.item.discount ? `${data.item.discount}$` : "-" }}
        </span>
      </template>
      <template #created_at="{ data }">
        <span class="nowrap-white-space">
          {{ toLocal(data.item.created_at) }}
        </span>
      </template>

      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 'deliverd'
              ? 'success'
              : data.item.status == 'panding'
              ? 'primary'
              : data.item.status == 'on hold'
              ? 'warning'
              : 'danger'
          "
          class="text-capitalize p-75"
          >{{ data.item.status }}
        </b-badge>
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-between"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="lg"
        pills
        class="my-2 d-flex justify-content-center"
      >
      </b-pagination>
    </div>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BPagination,
  BLink,
  BCard,
  BFormCheckbox,
  BForm,
  BFormInput,
  BBadge,
  VBTooltip,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import qs from "qs";
import VSelect from "vue-select";
import SelectBox from "@core/components/select-box/SelectBox.vue";
export default {
  components: {
    DataTable,
    VBTooltip,
    BButton,
    BModal,
    BCard,
    VBModal,
    BPagination,
    BLink,
    BFormCheckbox,
    BForm,
    BFormInput,
    BBadge,
    VSelect,
    SelectBox,
  },
  data() {
    return {
      url: "/panel/financial/transfers",
      pages: [],
      selectedPage: "",
      currentPage: 1,
      loading: false,
      pagination: {},
      types: [
        { label: "Id", value: "uuid" },
        // { label: "Discount", value: "discount" },   * Ree 500
        { label: "Status", value: "status" },
        // { label: "Amount", value: "amount" },    *Err 400 Requested filter(s) `amount` are not allowed.
        // { label: "From", value: "from" },    * data:[]
        // { label: "To", value: "to" },        * data:[]
      ],
      type: "",
      search: "",
      payable_type: "",
      payable_id: "",
      fields: [
        { key: "uuid", label: "id" },
        { key: "from", label: "from" },
        { key: "to", label: "to" },
        { key: "amount", label: "amount" },
        { key: "discount", label: "discount" },
        { key: "status", label: "status" },
        { key: "created_at", label: "created at" },
      ],
      transfers: [],
    };
  },
  directives: {
    "b-modal": VBModal,
    "b-tooltip": VBTooltip,
  },
  watch: {
    async type(val) {
      this.search = await "";
      this.payable_type = await "";
      this.payable_id = await "";
      if (this.$route.fullPath != "/financial/transfers") {
        this.$router.push({
          name: "financial-transfers",
        });
      }
    },
    currentPage(val) {
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "financial-transfers",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    $route: {
      handler(val) {
        this.getTransfers();
      },
      immediate: true,
      deep: true,
    },
    search(val) {
      if (!val) {
        if (this.$route.query.filter) {
          let filter = {};
          this.$router.push({
            name: "financial-transfers",
            query: {
              filter,
            },
          });
        }
      }
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.$router.push({
        name: "financial-transfers",
        query: {},
      });
    }
  },
  methods: {
    filter() {
      if (this.type) {
        let filter = {};
        if (this.type == "to") {
          filter = {
            to: {
              type: this.payable_type,
              id: this.payable_id,
            },
          };
        } else if (this.type == "from") {
          filter = {
            from: {
              type: this.payable_type,
              id: this.payable_id,
            },
          };
        } else {
          filter[this.type] = this.search;
        }
        if (this.type == "uuid") {
          if (this.validatorUuid(this.search)) {
            this.$router
              .push({
                name: "financial-transfers",
                query: {
                  ...this.$route.query,
                  filter,
                },
              })
              .catch((err) => {});
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "The id is invalid!",
                icon: "CoffeeIcon",
                variant: "warning",
              },
            });
          }
        } else {
          this.$router.push({
            name: "financial-transfers",
            query: {
              ...this.$route.query,
              filter,
            },
          });
        }
      } else if (this.$route.fullPath != "/financial/transfers") {
        this.$router.push({
          name: "financial-transfers",
        });
      }
    },
    doCopy(id) {
      this.$copyText(id).then(
        () => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Text copied",
              icon: "BellIcon",
            },
          });
        },
        (e) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Can not copy!",
              icon: "BellIcon",
            },
          });
        }
      );
    },
    async getTransfers() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.transfers = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
